const env = process.env.NODE_ENV;

const conf = {
  //API_ROOT: 'https://gate.meb.com/mall/web/',//默认正式环境地址
  API_ROOT: "https://apigate.meb.com/workorder", //默认正式环境地址
  UC_HOST: "https://uc.meierbei.com",
  AK: "TzuWQDM3hAgveswyA7pSZaUCgXwlejdg",
  SK: "NRCYSsRVtXw8cHadaik6QnvIFRFT7rPX",
};

if (env == "development") {
  //   conf.API_ROOT = `https://kongdev.meb.im/mall/web/`//开发环境
  //   conf.UC_HOST = 'https://uc.meb.im'
  conf.API_ROOT = `https://kongdev.t.meierbei.cn/workorder`; //开发环境
  conf.UC_HOST = "https://uc.t.meierbei.cn";
  conf.AK = "lvlvEdtprSjfsq9nGKlfX18mlRat3dr58";
  conf.SK = "lvlvEdtprSjfsq9nGKlfX18mlRat3dr58";
}
if (env == "staging") {
  //conf.API_ROOT = 'https://gate.meb.im/mall/web/';//测试环境
  conf.API_ROOT = "https://kongdev.t.meierbei.cn/mall/web/"; //测试环境
  conf.UC_HOST = "https://uc.t.meierbei.cn";
  conf.AK = "lvlvEdtprSjfsq9nGKlfX18mlRat3dr58";
  conf.SK = "lvlvEdtprSjfsq9nGKlfX18mlRat3dr58";
}

conf.CDN_HOST = "https://cdn-workorder.meb.com";

conf.SI_HOST = "https://si.meb.com";

conf.VIDEO_CDN_HOST = "https://video.meb.com";

module.exports = conf;
